import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { first } from 'rxjs';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';

import * as $ from 'jquery';
import { TimeScale } from 'chart.js';

@Component({
  selector: 'app-dastudentlist',
  templateUrl: './dastudentlist.component.html',
  styleUrls: ['./dastudentlist.component.scss']
})
export class DastudentlistComponent implements OnInit {


 district_list: any[] = this.ApiService.all_districts;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  district: any;
  constituency: string = '';
  OBConstituency: string;
  user_constituency: any = this.ApiService.all_constituency['Chennai North'];
  assigned_to: any;
  zones: any = this.ApiService.zones;
  user_name: any = this.ApiService.user_details.firstname;
  user_id: any = this.ApiService.user_details.id;
  activity_type: any;
  activity_date: any;
  activity_time: any;
  activity: any;
  description: any;
  status: any;
  others: any;
  customers: any = [];
  summary_activity: any = [];
    MeetingOptions:any;
  participantsptions:any;
  // districts:any=['Salem','Karur','Namakkal','Trichy'];
  createmeetingform !:FormGroup;
  constituencies!:any;
  meeting_name: any;
  meeting_time: any;
  meeting_date: any;
  participants: any;
  meeting_type: any;
  meeting_location: any;
  spinner: boolean;
  hidden:boolean=true;
  dropdownList : string[]= [];
  dropdownSettings: IDropdownSettings = {};
  add = [];
  name: any;
  father_name: any;
  DOB: any;
  email: any;
  number: any;
  parent_number: any;
  grade: any;
  college_name: any;
  subject: any;
  uploadFiles: any = '';
  password: any;
  confirm_password: any;
  

  
  
 
  selectedItems = [];
  
  dropDownForm: FormGroup;
  tableshow: boolean=false;
  editmeetingform !:FormGroup;
  CM_id: any;
  CM_zone: any;
  password_wrong: boolean = false;


  getChangeAssignedTo(assigned_to: any) {
    console.log(assigned_to)
    if (assigned_to === 'District') {
      $('#Check1').css('display','flex')
    } else {
       $('#Check1').css('display','none')
    }
      if (assigned_to === 'Zone') {
      $('#zones').css('display','block')
    } else {
       $('#zones').css('display','none')
    }
  }


  getChangeToConstituey(value: any) {
    console.log(value);
    this.user_constituency = this.ApiService.all_constituency[value];
      this.ApiService.datablelogin(value).subscribe((data: any) => {
      let obj = data;
        this.customers = obj.data;
  
      //console.log(obj.data.length);
    });
  }

  handleBlurChange() {
    let password = $('#password').val();
    let confirm_password = $('#confirm_password').val();
    if (password !== confirm_password) {
      this.password_wrong = true;
    } else {
      this.password_wrong = false;
    }
  }

  handleActivityTypeChange(value: any) {
    console.log(value);
    if (value === 'Others') {
      $('#others').css('display', 'block');
    } else {
        $('#others').css('display', 'none');
    }
  }



  handleDeleteClick(id: any) {
    
    $(`#adding_${id}`).remove();
  }

   onItemSelect(item: any) {
    console.log('onItemSelect', item);
  }
  onItemDeSelect(item: any) {
      console.log('onItemDeSelect', item);
  }
  onSelectAll(items: any) {
      console.log('onSelectAll', items);
  }
  onUnSelectAll() {
      console.log('onUnSelectAll fires');
  }

  

  constructor(private fb: FormBuilder,private ApiService: ApiServiceService,private router:Router,private spinnerService: NgxSpinnerService,
    public datepipe:DatePipe, private elementRef: ElementRef, private renderer: Renderer2) {
    this.createmeetingform= this.fb.group({
      name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      father_name:['',Validators.required,],
      DOB:[this.current_date,Validators.required],
      email:['',Validators.required],
      number:['',Validators.required],
      parent_number:['',Validators.required],
      grade:['',Validators.required],
      college_name:['',Validators.required],
      district:['',Validators.required],
      subject: ['', Validators.required],
      image: ['', Validators.required],
      password: ['', Validators.required],
      confirm_password: ['', Validators.required],
    });
    this.editformInitialize('false');

  }


  dtOptions: DataTables.Settings = {};
  date:any;
  ngOnInit(): void{
    console.log(this.users,this.users.district, "sndknsdkjn");
  this.date=new Date();
// document.write(today);
    this.customers=[];
    this.showSpinner();
    this.ApiService.getStudentsList(this.users.district).subscribe((data: any) => {
      console.log(data,"s,mfdnsd");
     
      this.customers=data;
      this.tableshow=true;
      //console.log(this.customers.length);
      //console.log(obj.data.length);
      console.log(this.customers,"dsdksbk");
      })

    // this.getdata();
    // this.ApiService.viewtableOB();
    // this.ApiService.viewtableDA();
    // this.ApiService.viewtableSA();
    // this.ApiService.viewtableOBapprove();
    // this.ApiService.viewtablemeeting();
    this.dtOptions = {
      pagingType: 'full_numbers'
    };

    const all_districts = this.ApiService.meeting_districts;
    this.dropdownList = all_districts;
  
   
    this.selectedItems = [
      { }
    ];
    this.dropDownForm = this.fb.group({
      meeting_district: [this.selectedItems]
  });
  
 

  }
  //Default date time in form
  current_date:any;
  current_time;any;
  setCurrentdate(){
    this.current_date=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    this.current_time=this.datepipe.transform(new Date(), 'HH:mm');
    this.createmeetingform.get('activity_date').setValue(this.current_date);
    this.createmeetingform.get('activity_time').setValue(this.current_time);
  }
  public showSpinner(): void {
    this.spinnerService.show();
    }

  
  getdata(){
    this.customers=[];
        for(const prop in this.ApiService.tabledatameeting) {
            this.customers.push(this.ApiService.tabledatameeting[prop])
          }
          this.customers.pop();
    //console.log(this.ApiService.tabledataDA)
    //this.ApiService.viewtableOB();
    

  }

    selectFiles(event:any) {
    console.log(event.target.files[0].name, "dnjsndk");
    if (event.target.files[0].size < 60000) {  
      const formData: FormData = new FormData();
      formData.append('file', event.target.files[0]);
      this.ApiService.uploadActivityFile(formData).subscribe((da: any) => {
        this.uploadFiles = da;
      })
  
    } else {
      alert('The size should be less than 60kb');
      $('#file').val('');
    }
    
  }


  handleClickNavigate(id: any) {
    this.router.navigate(['activity-summary', id]);
  }

  

  postdata(angForm1 : any) //angForm1
  {
    console.log(angForm1, "dsnkjkdsjnd");
        console.log(this.createmeetingform.status,
          angForm1,
          angForm1.value.meeting_name,
          angForm1.value.meeting_date,
        );
    let values = angForm1.value;
    values['image'] = this.uploadFiles;
    console.log(values,"djjs");
       
          this.spinner=true;

    this.ApiService.createStudentRegister(values).subscribe((d:any) => {
      console.log(d,"sdndsbjbdsskbskj"); 
              this.spinnerService.hide();
              setTimeout(function(){
                alert("Student Register has been created successfully!")
                window.location.href = 'login';
                },100)
                 
            //this.router.navigate(['superadmin/Meetings']);
             //angForm1.reset();
            },

            error => {
                console.log(error);
            });
            
         
    }
    delete_CM(id : any){
      console.log(id)
      if(confirm("Are you sure want to cancel this Student Details ?")) {
        console.log("Implement delete functionality here");
          this.ApiService.deleteStudentRegister(id)
          .pipe()
          .subscribe(
          data => {
              window.location.reload();
              alert("Student Details has been Deleted!")
          },

          error => {
              console.log(error);
          });

  }
}

    

  radiobutton(option:any){
    this.MeetingOptions=option;
    // console.log(this.MeetingOptions);
  }
  Participants(a:any){
    this.participantsptions=a;
//dropdown overlay reduced for mobileview
    const popupelement = this.elementRef.nativeElement.querySelector('.modal-content');
    if (popupelement) {
      const targetElement = popupelement.querySelector('.dropdown-list');
      if (targetElement) {
        this.renderer.setStyle(targetElement, 'overflow-y', 'hidden');
      }
    }
  }
  CM_name:any;
  CM_meeting_location:any;
  CM_date:any;
  CM_time: any;
  CM_description: any;
  CM_activity_type:any;
  CM_comments:any;
  CM_participants:any;
  CM_constituency: any;
  CM_assigned_to: any;
  CM_status: any;
  CM_activity: any;
  CM_others: any;
  CM_district: any;
  CM_father_name: any;
  CM_DOB: any;
  CM_email: any;
  CM_number: any;
  CM_parent_number: any;
  CM_grade: any;
  CM_college_name: any;
  CM_subject: any;
  CM_image: any;
  

editfield:boolean=false;
  buttonviewmeeting(a:any,editbutton:any ){
    console.log(a,editbutton,"dsbskdb");
    //console.log(a.date)
    if (editbutton == 'edit') {
      $('#card_title').html('STUDENT DETAILS EDIT');
      this.editfield = true;
    } else {
      $('#card_title').html('Student’s Details');
      this.editfield = false;

    }
    this.CM_name = a.name;
    this.CM_father_name = a.father_name;
    this.CM_DOB = a.DOB;
    this.CM_email = a.email;
    this.CM_number = a.number;
    this.CM_parent_number = a.parent_number;
    this.CM_grade = a.grade;
    this.CM_college_name = a.college_name;
    this.CM_district = a.district;
    this.CM_subject = a.subject;
    this.CM_image = a.image; 
    this.uploadFiles = a.image;
    this.CM_id = a.id;
          
          this.editformInitialize(false);
    
    this.editmeetingform.get('name').setValue(a.name);
    this.editmeetingform.get('father_name').setValue(a.father_name);
    this.editmeetingform.get('DOB').setValue(a.DOB);
    this.editmeetingform.get('email').setValue(a.email);
    this.editmeetingform.get('number').setValue(a.number);
    this.editmeetingform.get('parent_number').setValue(a.parent_number);
    this.editmeetingform.get('grade').setValue(a.grade);
    this.editmeetingform.get('college_name').setValue(a.college_name);
    this.editmeetingform.get('district').setValue(a.district);
    this.editmeetingform.get('subject').setValue(a.subject);


    }
                 
          
  editformInitialize(a){
    this.editmeetingform= this.fb.group({
        name: ['',[Validators.required, Validators.pattern('[A-Za-z ]{1,32}')]],
      father_name:['',Validators.required,],
      DOB:[this.current_date,Validators.required],
      email:['',Validators.required],
      number:['',Validators.required],
      parent_number:['',Validators.required],
      grade:['',Validators.required],
      college_name:['',Validators.required],
      district:['',Validators.required],
      subject: ['', Validators.required],
      image: ['', Validators.required],
      
  });
  }

  updatedata(updateform,id){
    console.log(updateform.value, this.CM_id, "lmdldk");  
    let values = updateform.value;
    values['image'] = this.uploadFiles;
    // this.spinner = true;
    this.ApiService.updateStudentRegister(this.CM_id,values).pipe().subscribe(
      data => {
        console.log(data);
        this.spinnerService.hide();
        setTimeout(function () {
          Swal.fire({
title: "Student Registration has been updated!",
icon: "success",
confirmButtonText: "Okay",
iconColor:'#015792',
confirmButtonColor: '#015792',
}).then((result) => {
/* Read more about isConfirmed, isDenied below */
if (result.isConfirmed) {
window.location.reload();
} 
});
}, 100)
            
        },
      
      error => {
        console.log(error);
      });
  }
//reset form values in createform
  Formreset(){
      this.createmeetingform.reset();
      this.hidden=true;
      this.MeetingOptions='';
      this.participantsptions='';
  }

}
